export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/9c004d6f62865f7af24a6b7c5c519d60.png"
              alt="BR CLEAN AUTO"
              className="h-20 w-auto object-contain mb-6"
            />
            <p className="text-gray-300 text-sm mb-6 max-w-md">
              Service professionnel de nettoyage automobile mobile à Clermont-Ferrand. Nous redonnons à votre véhicule tout son éclat, où que vous soyez.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/BR_.clean63"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#0EA5E9] transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="tel:0695104394"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#0EA5E9] transition-colors"
              >
                <i className="ri-phone-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('accueil')}
                  className="text-gray-300 hover:text-[#0EA5E9] transition-colors text-sm whitespace-nowrap"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('prestations')}
                  className="text-gray-300 hover:text-[#0EA5E9] transition-colors text-sm whitespace-nowrap"
                >
                  Prestations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-[#0EA5E9] transition-colors text-sm whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-300 hover:text-[#0EA5E9] transition-colors text-sm whitespace-nowrap"
                >
                  Galerie
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#0EA5E9] mt-1 mr-2"></i>
                <a href="tel:0695104394" className="text-gray-300 hover:text-white transition-colors text-sm whitespace-nowrap">
                  06 95 10 43 94
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#0EA5E9] mt-1 mr-2"></i>
                <span className="text-gray-300 text-sm">
                  Clermont-Ferrand<br />et environs
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-[#0EA5E9] mt-1 mr-2"></i>
                <span className="text-gray-300 text-sm">
                  Sur rendez-vous
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} BR CLEAN AUTO. Tous droits réservés.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#0EA5E9] transition-colors text-sm whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}